<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="offset-2 col-lg-6">
        <div class="card">
          <div class="header text-center">
            <h2>Change Password</h2>
          </div>
         <div class="body">
           <!--<form id="basic-form" method="post" novalidate>
             <div class="form-group">
               <label>Old Password</label>
               <input type="password" class="form-control" placeholder="Old Password" required>
             </div>
             <div class="form-group">
               <label>New Password</label>
               <input type="Password" class="form-control" placeholder="New Password" required>
             </div>
             <div class="form-group">
               <label>Confirm Password</label>
               <input type="Password" class="form-control" placeholder="Confirm Password" required>
             </div>
             <div class="text-center">
               <button type="submit" class="btn btn-primary btn-block">Update Password</button></div>
           </form>-->


           <form novalidate (ngSubmit)="updatePassword()">
             <div class="pl-lg-4">
               <div class="row">
                 <div class="col-lg-12">
                   <div class="form-group">
                     <label class="form-control-label" for="input-password">Old Password</label>
                     <input type="password" id="input-password" class="form-control" placeholder="Enter old password" [(ngModel)]="password.old_password"
                            [ngModelOptions]="{standalone: true}">
                   </div>
                 </div>

               </div>
               <div class="row">
                 <div class="col-lg-12">
                   <div class="form-group">
                     <label class="form-control-label" for="input-new-password">New Password</label>
                     <input type="password" id="input-new-password" class="form-control"
                            placeholder="Enter new password" [(ngModel)]="password.new_password"
                            [ngModelOptions]="{standalone: true}">
                   </div>
                 </div>

               </div>
               <div class="row">
                 <div class="col-lg-12">
                   <div class="form-group">
                     <label class="form-control-label" for="input-confirm-password">Confirm Password</label>
                     <input type="password" id="input-confirm-password" class="form-control"
                            placeholder="Confirm new password" [(ngModel)]="password.new_password_confirmation"
                            [ngModelOptions]="{standalone: true}">
                   </div>
                 </div>

               </div>
               <div class="row text-center">
                 <div class="col-12">
                   <button class="btn btn-danger" type="submit"  *ngIf="!isUpdatingP" [disabled]="!password.old_password  || !password.new_password || !password.new_password_confirmation" >Update Password</button>
                   <button class="btn btn-danger" type="button" [disabled]="true" *ngIf="isUpdatingP">Saving&nbsp;<i class="fa fa-spin fa-spinner"></i></button>
                 </div>
               </div>
             </div>
           </form>

         </div>
        </div>
      </div>

    </div>



  </div>
</div>
